module.exports = __webpack_public_path__ + "static/media/08_insideyourblood.8041c832.jpg";